import { getClient } from '@api/client';
import type { LiveServicesMapping } from '../../lib/state';
import { getLiveServicesMappingsQuery } from './getLiveServicesMappingsQuery';

async function getLiveServicesMappings(): Promise<LiveServicesMapping[]> {
  const { data } = await getClient().query({
    query: getLiveServicesMappingsQuery,
    fetchPolicy: 'network-only',
  });

  return data?.liveServicesNumberMappings ?? [];
}

export default getLiveServicesMappings;
